(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const faqItems = document.querySelectorAll('.faq-item');

    faqItems.forEach((item) => {
      const summary = item.querySelector('.faq-question');
      const content = item.querySelector('.faq-answer');
      const inner = item.querySelector('.faq-answer-inner');
      const chevron = item.querySelector('.faq-chevron');

      summary.addEventListener('click', (e) => {
        e.preventDefault();

        const isOpen = item.hasAttribute('open');

        // Close all other items
        faqItems.forEach((otherItem) => {
          if (otherItem !== item && otherItem.hasAttribute('open')) {
            closeItem(otherItem);
          }
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    function openItem(item) {
      const content = item.querySelector('.faq-answer');
      const inner = item.querySelector('.faq-answer-inner');
      const chevron = item.querySelector('.faq-chevron');

      item.setAttribute('open', '');
      content.style.maxHeight = inner.offsetHeight + 'px';
      chevron.style.transform = 'rotate(90deg)';

      // Trigger reflow to ensure transition works
      content.offsetHeight;

      inner.style.opacity = '1';
      inner.style.transform = 'translateY(0)';
    }

    function closeItem(item) {
      const content = item.querySelector('.faq-answer');
      const inner = item.querySelector('.faq-answer-inner');
      const chevron = item.querySelector('.faq-chevron');

      content.style.maxHeight = '0px';
      inner.style.opacity = '0';
      inner.style.transform = 'translateY(-10px)';
      chevron.style.transform = 'rotate(0deg)';

      // Remove the 'open' attribute after transition
      content.addEventListener(
        'transitionend',
        () => {
          item.removeAttribute('open');
        },
        { once: true }
      );
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class SliderProgress {
    constructor(sliderElement) {
      this.slider = sliderElement;
      this.progressBar = this.slider.querySelector('.slider-progress');
      if (!this.progressBar) {
        console.error('Progress bar not found in slider');
        return;
      }
      this.totalSlides = parseInt(this.slider.dataset.productsToShow, 10) || 1;
      this.currentSlide = 1;

      this.init();
    }

    init() {
      this.createProgressSegments();
      this.determineInitialSlide();
      this.updateProgressBar();
      this.attachEventListeners();
      this.addSlideIndexes();
    }

    createProgressSegments() {
      const progressContainer = this.slider.querySelector('.slider-progress');
      progressContainer.innerHTML = ''; // Clear existing content

      for (let i = 0; i < this.totalSlides; i++) {
        const segment = document.createElement('div');
        segment.classList.add('progress-segment');
        segment.style.width = `${100 / this.totalSlides}%`;
        segment.innerHTML = '&nbsp;'; // Add non-breaking space
        progressContainer.appendChild(segment);
      }

      this.progressSegments = progressContainer.querySelectorAll('.progress-segment');
    }

    updateProgressBar() {
      this.progressSegments.forEach((segment, index) => {
        if (index < this.currentSlide) {
          segment.classList.add('active');
        } else {
          segment.classList.remove('active');
        }
      });
    }

    attachEventListeners() {
      const prevButton = this.slider.querySelector('.slider-button--prev');
      const nextButton = this.slider.querySelector('.slider-button--next');

      if (prevButton) {
        prevButton.addEventListener('click', () => this.goToPrevSlide());
      }
      if (nextButton) {
        nextButton.addEventListener('click', () => this.goToNextSlide());
      }

      // Listen for slide change events (including swipe)
      this.slider.addEventListener('slider:slide-change', (event) => {
        this.setCurrentSlide(event.detail.currentSlide);
      });

      // Listen for swipe events
      this.slider.addEventListener('touchstart', (e) => this.handleTouchStart(e));
      this.slider.addEventListener('touchmove', (e) => this.handleTouchMove(e));
      this.slider.addEventListener('touchend', (e) => this.handleTouchEnd(e));

      // Add intersection observer to detect visible slides
      this.setupIntersectionObserver();
    }

    addSlideIndexes() {
      const slides = this.slider.querySelectorAll('.slider__slide');
      slides.forEach((slide, index) => {
        slide.dataset.slideIndex = index + 1;
      });
    }

    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const slideIndex = parseInt(entry.target.dataset.slideIndex, 10);
            this.setCurrentSlide(slideIndex);
          }
        });
      }, options);

      const slides = this.slider.querySelectorAll('.slider__slide');
      slides.forEach((slide) => observer.observe(slide));
    }

    goToPrevSlide() {
      if (this.currentSlide > 1) {
        this.currentSlide--;
        this.updateProgressBar();
      }
    }

    goToNextSlide() {
      if (this.currentSlide < this.totalSlides) {
        this.currentSlide++;
        this.updateProgressBar();
      }
    }

    setCurrentSlide(slideNumber) {
      this.currentSlide = Math.max(1, Math.min(slideNumber, this.totalSlides));
      this.updateProgressBar();
    }

    // Swipe handling
    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    }

    handleTouchMove(e) {
      if (!this.touchStartX) {
        return;
      }
      this.touchEndX = e.touches[0].clientX;
    }

    handleTouchEnd(e) {
      if (!this.touchStartX || !this.touchEndX) {
        return;
      }
      const diff = this.touchStartX - this.touchEndX;
      if (diff > 50) {
        // Swipe left
        this.goToNextSlide();
      } else if (diff < -50) {
        // Swipe right
        this.goToPrevSlide();
      }
      this.touchStartX = null;
      this.touchEndX = null;
    }

    determineInitialSlide() {
      const visibleSlide = this.findVisibleSlide();
      if (visibleSlide) {
        const slideIndex = parseInt(visibleSlide.dataset.slideIndex, 10);
        this.setCurrentSlide(slideIndex);
      }
    }

    findVisibleSlide() {
      const slides = this.slider.querySelectorAll('.slider__slide');
      const sliderRect = this.slider.getBoundingClientRect();

      for (const slide of slides) {
        const slideRect = slide.getBoundingClientRect();
        if (slideRect.left >= sliderRect.left && slideRect.right <= sliderRect.right) {
          return slide;
        }
      }

      return null;
    }
  }

  // Initialize SliderProgress instances
  document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('slider-component');
    sliders.forEach((slider) => {
      new SliderProgress(slider);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
        invertNav();
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
                  this.closeSearchModal();
                  invertNav();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  removeInvertedNav();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

/*
Navigation Inversion
*/


   // Set the initial state of the navigation on home page 
  //if inverted-navigation class is present, make navigation transparent
  if (document.querySelector('.inverted-navigation')) {
    setInvertedNavigation(true);
  }

  function setInvertedNavigation(isInverted) {
    const elements = {
      mainContent: document.getElementById('MainContent'),
      headerWrapper: document.querySelector('.header-wrapper'),
      searchText: document.querySelector('.search-text-b'),
      menuItems: document.querySelectorAll('.header__menu-item'),
      headerLogo: document.querySelector('.header__heading-logo'),
      headerIcons: document.querySelectorAll('.header__icon svg'),
      accountIcon: document.querySelector('.icon-account'),
      cartIcon: document.querySelector('.icon-cart'),
      chevronNavs: document.querySelectorAll('.chevron-nav'),
      headerWrapperBosie: document.querySelector('.header-wrapper-bosie')
    };

    const classActions = {
      add: ['inverted-body', 'inverted-navigation', 'invert-text', 'invert-icons', 'inverted-underline'],
      remove: ['fill-inverted-background']
    };

    if (isInverted) {
      elements.mainContent.classList.add(classActions.add[0]);
      elements.headerWrapper.classList.add(classActions.add[1]);
      elements.searchText.classList.add(classActions.add[2]);
      elements.menuItems.forEach(item => item.classList.add(classActions.add[2]));
      addClassToSVG(elements.headerLogo, classActions.add[3]);
      elements.headerIcons.forEach(icon => addClassToSVG(icon, classActions.add[3]));
      elements.menuItems[0].classList.add(classActions.add[4]);
      addClassToSVG(elements.accountIcon, classActions.add[3]);
      addClassToSVG(elements.cartIcon, classActions.add[3]);
      elements.chevronNavs.forEach(icon => addClassToSVG(icon, classActions.add[3]));
      elements.headerWrapperBosie.classList.remove(classActions.remove[0]);
    } else {
      elements.mainContent.classList.remove(classActions.add[0]); 
      elements.headerWrapper.classList.remove(classActions.add[1]);
      elements.searchText.classList.remove(classActions.add[2]);
      elements.menuItems.forEach(item => item.classList.remove(classActions.add[2]));
      removeClassFromSVG(elements.headerLogo, classActions.add[3]);
      elements.headerIcons.forEach(icon => removeClassFromSVG(icon, classActions.add[3]));
      elements.menuItems[0].classList.remove(classActions.add[4]);
      removeClassFromSVG(elements.accountIcon, classActions.add[3]);
      removeClassFromSVG(elements.cartIcon, classActions.add[3]);
      elements.chevronNavs.forEach(icon => removeClassFromSVG(icon, classActions.add[3]));
      // elements.headerWrapperBosie.classList.add(classActions.remove[0]);
    }
  }
    // Make setInvertedNavigation available globally
    window.setInvertedNavigation = setInvertedNavigation;


  function addClassToSVG(element, className) {
    if (element && element.classList) {
      element.classList.add(className);
    } else if (element && element.setAttribute) {
      const classes = (element.getAttribute('class') || '').split(' ');
      if (!classes.includes(className)) {
        classes.push(className);
        element.setAttribute('class', classes.join(' '));
      }
    }
  }

  function removeClassFromSVG(element, className) {
    if (element && element.classList) {
      element.classList.remove(className);
    } else if (element && element.setAttribute) {
      const classes = (element.getAttribute('class') || '').split(' ');
      const index = classes.indexOf(className);
      if (index !== -1) {
        classes.splice(index, 1);
        element.setAttribute('class', classes.join(' '));
      }
    }
  }

  function invertNav() {
    if (document.querySelector('.inverted-navigation')) {
      setInvertedNavigation(true);
    }
  }

  // Navigation hover set to remove inverted navigation
  let navigationHover = false;
  function setNavigationHover() {
    navigationHover = true;
    console.log('nav hover set to: ' + navigationHover);
    setInvertedNavigation(false);
    document.getElementById('MainContent').classList.add('fill-inverted-background');
  }
  function removeNavigationHover() {
    navigationHover = false;
    console.log('nav hover set to: ' + navigationHover);
    
  }
  
  if (navigationHover) {
    removeInvertedNav();
  }

  function removeInvertedNav() {
    if (document.querySelector('.inverted-navigation')) {
      setInvertedNavigation(false);
    }
    
  }

  // Make setInvertedNavigation available globally
  window.setInvertedNavigation = setInvertedNavigation;

  // Hover on inverted navigation set to remove inverted navigation
  document.querySelector('.header-wrapper-bosie').addEventListener('mouseover', setNavigationHover);
  document.querySelector('.header-wrapper-bosie').addEventListener('mouseout', removeNavigationHover);

 


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Debounce function to limit how often a function is called
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Function to move the element
  function moveMediaWrapper() {
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const priceElement = document.querySelector(`[id^="price-"][id$="__main"]`);
    const productInfoWrapper = document.querySelector('.product__info-wrapper');
    if (!mediaWrapper || !priceElement || !productInfoWrapper) return;

    if (window.innerWidth <= 768) {
      // Mobile breakpoint
      priceElement.parentNode.insertBefore(mediaWrapper, priceElement.nextSibling);
    } else {
      const productContainer = document.querySelector('.product');
      productContainer.insertBefore(mediaWrapper, productInfoWrapper);
    }
  }

  // Debounced version of moveMediaWrapper
  const debouncedMoveMediaWrapper = debounce(moveMediaWrapper, 450);

  // Call the function on page load
  document.addEventListener('DOMContentLoaded', moveMediaWrapper);

  // Call the debounced function when the window is resized
  window.addEventListener('resize', debouncedMoveMediaWrapper);

  function initSizeGuide() {
    const table = document.querySelector('.size-guide');
    const toggleContainer = document.getElementById('toggleContainer');

    // Create toggle switch
    toggleContainer.innerHTML = `
       <h4 class="dimensions-title">Dimensions shown in:</h4> 
          <label class="toggle ">
            <input type="checkbox" type="checkbox" id="unitToggle">
          <span class="slider-toggle slider-size-guide"></span>
          <span class="toggle-text cm">IN</span>
          <span class="toggle-text in">CM</span>
      </label>
      `;

    const unitToggle = document.getElementById('unitToggle');
    const unitLabel = document.getElementById('unitLabel');

    function convertToInches(cm) {
      return (cm / 2.54).toFixed(1);
    }

    function updateTable(showInches) {
      const rows = table.querySelectorAll('tr');
      rows.forEach((row, rowIndex) => {
        if (rowIndex === 0) return; // Skip header row
        const cells = row.querySelectorAll('td');
        cells.forEach((cell, cellIndex) => {
          if (cellIndex === 0) return; // Skip first column
          const value = parseFloat(cell.getAttribute('data-cm') || cell.textContent);
          const displayValue = showInches ? convertToInches(value) : value;
          cell.textContent = `${displayValue}${showInches ? '"' : 'cm'}`;
        });
      });
    }

    // Store original cm values as data attributes
    const cells = table.querySelectorAll('td');
    cells.forEach((cell) => {
      if (!isNaN(parseFloat(cell.textContent))) {
        cell.setAttribute('data-cm', cell.textContent);
      }
    });

    unitToggle.addEventListener('change', function () {
      updateTable(this.checked);
      unitLabel.textContent = this.checked ? 'Show in Inches' : 'Show in Centimeters';
    });

    // Initial table setup
    updateTable(false);
  }

  // Initialize the size guide
  document.addEventListener('DOMContentLoaded', initSizeGuide);

  // Append modal opener to variant-selects, and re-append after variant changes
  document.addEventListener('DOMContentLoaded', function () {
    const modalOpener = document.querySelector('.modal-opener');
    if (!modalOpener) return;

    function appendSizeGuide() {
      const variantSelects = document.querySelector('.variant-selects');
      if (variantSelects && !variantSelects.contains(modalOpener)) {
        variantSelects.appendChild(modalOpener);
      }
    }

    appendSizeGuide();

    // Re-append after variant selection replaces the variant-selects element
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const observer = new MutationObserver(function () {
        appendSizeGuide();
      });
      observer.observe(productInfo, { childList: true, subtree: true });
    }
  });

  class ProductMediaGallery {
    constructor() {
      this.init();
    }

    init() {
      this.slider = document.querySelector('.product__media-list');
      if (!this.slider) {
        console.log('Slider not found, retrying in 500ms');
        setTimeout(() => this.init(), 500);
        return;
      }

      console.log('Slider found:', this.slider);

      this.sectionId = this.slider.closest('[data-section-id]')?.dataset.sectionId;
      this.slides = this.slider.querySelectorAll('.product__media-item');
      this.counterBars = document.querySelectorAll('.slider-counter__bar');

      console.log('Section ID:', this.sectionId);
      console.log('Slides:', this.slides.length);
      console.log('Counter bars:', this.counterBars.length);

      this.currentIndex = 0;
      this.isScrolling = false;
      this.touchStartX = 0;
      this.touchEndX = 0;

      this.updateSliderCounter = this.updateSliderCounter.bind(this);
      this.handleTouchStart = this.handleTouchStart.bind(this);
      this.handleTouchMove = this.handleTouchMove.bind(this);
      this.handleTouchEnd = this.handleTouchEnd.bind(this);
      this.handleScroll = this.handleScroll.bind(this);

      this.slider.addEventListener('touchstart', this.handleTouchStart, { passive: true });
      this.slider.addEventListener('touchmove', this.handleTouchMove, { passive: true });
      this.slider.addEventListener('touchend', this.handleTouchEnd);
      this.slider.addEventListener('scroll', this.handleScroll);

      // Add click event listeners to the counter bars
      this.counterBars.forEach((bar, index) => {
        bar.addEventListener('click', () => this.goToSlide(index));
      });

      // Initial update of the counter
      this.updateSliderCounter(0);
    }

    handleTouchStart(e) {
      this.touchStartX = e.touches[0].clientX;
    }

    handleTouchMove(e) {
      this.touchEndX = e.touches[0].clientX;
    }

    handleTouchEnd() {
      if (this.touchStartX - this.touchEndX > 50) {
        // Swipe left
        this.goToSlide(Math.min(this.currentIndex + 1, this.slides.length - 1));
      } else if (this.touchEndX - this.touchStartX > 50) {
        // Swipe right
        this.goToSlide(Math.max(this.currentIndex - 1, 0));
      }
    }

    handleScroll() {
      if (!this.isScrolling) {
        window.requestAnimationFrame(() => {
          const scrollLeft = this.slider.scrollLeft;
          const slideWidth = this.slides[0].offsetWidth;
          const newIndex = Math.round(scrollLeft / slideWidth);
          if (newIndex !== this.currentIndex) {
            this.currentIndex = newIndex;
            this.updateSliderCounter(this.currentIndex);
          }
          this.isScrolling = false;
        });
      }
      this.isScrolling = true;
    }

    updateSliderCounter(index) {
      this.counterBars.forEach((bar, i) => {
        if (i === index) {
          bar.setAttribute('aria-current', 'true');
          bar.classList.add('slider-counter__bar--active');
        } else {
          bar.removeAttribute('aria-current');
          bar.classList.remove('slider-counter__bar--active');
        }
      });

      this.slides.forEach((slide, i) => {
        if (i === index) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }

    goToSlide(index) {
      this.currentIndex = index;
      this.updateSliderCounter(index);
      this.slider.scrollLeft = index * this.slides[0].offsetWidth;
    }
  }

  // Initialize the gallery
  document.addEventListener('DOMContentLoaded', () => {
    new ProductMediaGallery();
  });

  } catch(e) { console.error(e); }
})();
})();
